import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import * as moment from 'moment';




@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html'
})
export class BottomSheetComponent implements OnInit {
  search: any = {};
  today_date: any = new Date();
  lastPageData: any = {}
  monthlyWorkReport: any = []
  states: any = [];


  maxDate: any;
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public service: DatabaseService, private bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>, public toast: ToastrManager) {
    this.lastPageData = data;
    console.log(this.lastPageData)
    if (this.lastPageData.filterPage == 'Expense'||this.lastPageData.filterPage == 'attendance_list' ) {
      this.getSalesUser('');
    }
    if (this.lastPageData.filterPage == 'order_vs_dispatch') {
      this.getStateList();
    }
    if (this.lastPageData.filterPage == 'product_wise_secondary_report') {
      this.getSalesUser('');
    }

    if (this.lastPageData.filterPage == 'survey_list') {
      this.getSalesUser('');
    }

    if (this.lastPageData.filterPage == 'getContractorMeetList') {
      this.getSalesUser('');
    }

  }

  ngOnInit() {
  }
  public date(date) {
    if (this.search.date_from) {
      this.search.date_from = moment(this.search.date_from).format('YYYY-MM-DD');
    }
    if (this.search.date_to) {
      this.search.date_to = moment(this.search.date_to).format('YYYY-MM-DD');
    }
  }
  salesUser: any = [];
  getSalesUser(searchValue) {
    let header;
    if (this.lastPageData.filterPage == 'Expense') {
      header = 'Expense/salesUserListExpense';
    }


    if (this.lastPageData.filterPage == 'product_wise_secondary_report'||this.lastPageData.filterPage == 'attendance_list' || this.lastPageData.filterPage == 'survey_list' || this.lastPageData.filterPage == 'getContractorMeetList') {
      header = 'Expense/salesUserList';

    }
    this.service.post_rqst({ 'search': searchValue }, header).subscribe((response => {
      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
        if (this.lastPageData.filterPage == 'product_wise_secondary_report') {
          this.salesUser.unshift({ 'id': 'All', 'name': 'All', 'role_name': '' })
        }
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }



  getValue() {
    this.bottomSheetRef.dismiss(this.search);
  }


  setDateToLimit(dateFrom) {
    this.maxDate = new Date(dateFrom);
    if (dateFrom) { this.maxDate.setMonth(dateFrom.getMonth() + 3); }
    else { this.maxDate.setMonth(dateFrom.getMonth() + 1); }

    this.maxDate.setDate(dateFrom.getDate() - 1);
    if (this.maxDate > this.today_date) { this.maxDate = this.today_date }
  }

  allSalesUser1(action) {



    if (this.search.allSalesUser == true) {
      const productData = [];
      for (let i = 0; i < this.salesUser.length; i++) {
        productData.push(this.salesUser[i].id)
      }
      this.search.user_id = productData;
      console.table(this.search.user_id)

    } else {
      this.search.user_id = [];
      console.table(this.search.to_user_id)
    }
  }

  getStateList() {
    this.service.post_rqst(0, "Master/getAllState").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.states = result['all_state'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }




}
